import { useTranslation } from "react-i18next";

import Button from "@krea/customer-features/shared-components/button";
import { AppModal } from "@krea/shared/design-system/modal";

import { useSelectCurrentLoanApplication } from "store/current-loan-application/hooks/mutations";
import { useGetCurrentLoanApplication } from "store/current-loan-application/hooks/queries";
import { useGetLoanApplications } from "store/loan-applications/hooks/queries";

import { ApplicationsSelectorItem } from "./ApplicationsSelectorItem";

interface IChangeApplicationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const ChangeApplicationModal = ({
  open,
  setOpen,
}: IChangeApplicationModalProps) => {
  const { t } = useTranslation();

  const { data: activeLoanApplications } = useGetLoanApplications(open);
  const { data } = useGetCurrentLoanApplication();
  const { mutate: changeCurrentLoanApplication } =
    useSelectCurrentLoanApplication();
  const { id: currentLoanApplicationID } = data ?? {};

  const onChangeCurrentApplication = (id: string) => {
    if (currentLoanApplicationID !== id) {
      changeCurrentLoanApplication(
        { loanApplicationID: id },
        {
          onSuccess: () => setOpen(false),
        },
      );
    }
  };

  return (
    <AppModal
      open={open}
      setOpen={setOpen}
      lockOutsideInteraction={false}
      footer={
        <Button
          variant="text"
          onClick={() => setOpen(false)}
          id="modal-cancel-button"
        >
          {t("applicationSelector.cancel")}
        </Button>
      }
      className="tw-mt-3 tw-max-h-[70vh] tw-py-0"
    >
      <div className="tw-grid tw-grid-cols-1 tw-gap-2 tw-pt-2">
        {activeLoanApplications?.map((item) => (
          <ApplicationsSelectorItem
            key={item.id}
            data={item}
            checked={item.id === currentLoanApplicationID}
            onClick={() => onChangeCurrentApplication(item.id)}
          />
        ))}
      </div>
    </AppModal>
  );
};
